export enum SocialMediaPlatformTableType {
	Mutable,
	ReadOnly,
	Reporting,
}
